import React from "react"

interface AnchorLinkContextProviderProps {
	activeId: string
	children: React.ReactNode
}

export const AnchorLinkContext = React.createContext({
	activeId: "",
})

export const AnchorLinkContextProvider: React.FC<AnchorLinkContextProviderProps> =
	(props) => {
		return (
			<AnchorLinkContext.Provider value={{ activeId: props?.activeId ?? null }}>
				{props.children}
			</AnchorLinkContext.Provider>
		)
	}
